'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxForm = require('redux-form');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isObject = require('lodash/isObject');var _isObject2 = _interopRequireDefault(_isObject);
var _components = require('../../components');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var selector = (0, _reduxForm.formValueSelector)('PublishForm');

var PropertyCellDynamicPreview = function PropertyCellDynamicPreview(props) {var
  translate = props.translate,locale = props.locale,isMobile = props.isMobile,isRtl = props.isRtl,propertyData = props.propertyData,routeData = props.routeData;var

  searchOption =









  propertyData.searchOption,property_type = propertyData.property_type,_propertyData$address = propertyData.address,addressData = _propertyData$address === undefined ? {} : _propertyData$address,images = propertyData.images,rooms = propertyData.rooms,parking = propertyData.parking,_propertyData$floor = propertyData.floor,floorData = _propertyData$floor === undefined ? {} : _propertyData$floor,groundFloor = propertyData.groundFloor,videos = propertyData.videos,areaObject = propertyData.area;

  var propertyType = property_type && translate('propertyTypes', property_type).toString();

  var englishAddressRequired = _constants.localesWithEnglishAddress.includes(locale);
  var address = addressData && (englishAddressRequired ?
  addressData.en :
  addressData[locale] || addressData[_constants.language.default]);

  var city = address && address.city_name;
  var houseNumber = address && address.house_number ? ' ' + address.house_number + ',' : '';
  var addressString = address && address.street_name && address.street_name + ' ' + houseNumber;

  var isLand = property_type === 'land';
  var floor = isLand ? undefined : floorData.on_the;
  var roomsData = isLand ? undefined : rooms;
  var area = (0, _isObject2.default)(areaObject) ? areaObject.base : areaObject;

  return (
    _react2.default.createElement('div', null,
      _react2.default.createElement(_components.OMPropertyDynamicPreviewCell, {
        locale: locale,
        routeData: routeData,
        isMobile: isMobile,
        isRtl: isRtl,
        searchOption: searchOption,
        propertyType: propertyType,
        photo: (0, _get2.default)(images, '[0].thumbnail', ''),
        videoPoster: (0, _get2.default)(videos, '[0].thumbnail', ''),
        images: images,
        price: propertyData.price,
        currency: propertyData.currency,
        address: addressString,
        city: city,
        rooms: roomsData,
        parkingSpots: parking,
        area: area,
        floor: floor,
        groundFloor: groundFloor,
        groundFloorTitle: translate('propertyDetails', 'details', 'groundFloorShortcut').toString(),
        translate: translate })));



};

PropertyCellDynamicPreview.propTypes = {
  propertyData: _propTypes2.default.object,
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  routeData: _propTypes2.default.object };


var mapStateToProps = function mapStateToProps(state) {return {
    locale: state.lang.locale,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    isMobile: state.windowDimentions.isMobile,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    propertyData: {
      searchOption: selector(state, 'sub_option'),
      property_type: selector(state, 'property_type'),
      address: selector(state, 'address'),
      area: selector(state, 'area'),
      rooms: selector(state, 'rooms'),
      floor: selector(state, 'floor'),
      groundFloor: selector(state, 'groundFloor'),
      parking: selector(state, 'parking'),
      price: selector(state, 'price'),
      images: selector(state, 'images'),
      currency: selector(state, 'currency'),
      videos: selector(state, 'videos') } };};exports.default =



(0, _reactRedux.connect)(mapStateToProps, null)(PropertyCellDynamicPreview);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertyCellDynamicPreview/PropertyCellDynamicPreview.js
// module id = 2988
// module chunks = 0